import {makeStyles, Portal} from "@material-ui/core";
import {styles} from "../utils/styles";
import {contentNoPaddingRef} from "../utils/utilities";
import Iframe from "react-iframe";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
	...styles
}));

function PhotoEDUReportSales() {
	const classes = useStyles();

	return (
		<Portal container={contentNoPaddingRef.current}>
			<Iframe
				url="https://cnc-api.zmags.com/view/lite/62a74f0ea3dd51437600d976"
				className={clsx(classes.iFrame, "flex")}
			/>
		</Portal>
	);
}

export default PhotoEDUReportSales;